import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNewspaper3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="newspaper-3"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.25 15.25H17.75M12.75 12H17.75M12.75 8.75H17.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.25 8.75V12H8.875L6.625 8.75H6.25V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconNewspaper3;
